// Wire-format types mirroring crates/publish/src/manifest.rs. Bumping the
// schema requires a coordinated server + client release.

export const MANIFEST_SCHEMA_VERSION = 1;

export interface ManifestEntry {
  id: number;
  title: string;
  // ≤30-word LLM summary, surfaced on the list-view card. Optional
  // because the manifest field is "" when no enrichment merged in;
  // ArticleCard treats missing/empty as "render no preview line".
  summary?: string;
  score: number;
  // Component scores in [0.0, 1.0] — same axes the server uses to
  // compose `score`, exposed individually so the PWA can re-weight
  // them. Optional because pre-PR-#75 manifests don't carry them
  // (rank.ts handles undefined as 0 so the math still works).
  recency_score?: number;
  source_authority_score?: number;
  engagement_velocity_score?: number;
  novelty_score?: number;
  tags?: string[];
  publisher?: string;
  url: string;
  published_at: number; // epoch ms
  image_url?: string;
}

export interface ArticleDetail extends ManifestEntry {
  summary: string;
  dek?: string;
  byline?: string;
  sentiment?: string;
  language?: string;
}

export interface Manifest {
  schema_version: number;
  generated_at: number; // epoch ms
  articles: ManifestEntry[];
}
